$(document).ready(function(){

  
  $(document).on('click', '#read_more_text', function() { 
      let parentID = $(this).parents('.before-description');  
      parentID.next('.after-description').css("display", "flex");
      parentID.css("display", "none");
  });

  $(document).on('click', '#read_less_text', function() { 
      let parentID = $(this).parents('.after-description'); 
      parentID.css("display", "none");
      parentID.prev('.before-description').css("display", "flex");
  });


    function cartCount(){ 
        $.getJSON('/cart.js', function(cart) { 
            $(".cart-count-bubble > span").html(cart.item_count); 
            if(cart.item_count >= 1){
                $('cart-drawer.cdesk-cart-drawer').removeClass('is-empty').addClass('active'); $('body').addClass('overflow-hidden');
                $('#cart-icon-bubble').append('<div class="cart-count-bubble" bis_skin_checked="1"><span aria-hidden="true">'+cart.item_count+'</span><span class="visually-hidden">'+cart.item_count+' items</span></div>')
            }       
        });
    }   

    function updateMiniCart(currentThis){
        $.ajax({
            type: "GET", 
            url: "/",
            dataType: 'html',

            success: function(data) 
            {
            var miniCartHead = $(data).contents('#CartDrawer').find('.drawer__inner').html(); 
            $('#CartDrawer .drawer__inner').html(miniCartHead);  
            }
        })
    }



    function ajaxAddToCartProduct(currentThis,dynamicData) {   
        $.ajax({
          url: "/cart/add.js",
          type: "POST",
          data: {items:dynamicData},
          dataType: "json",
          success: function(data){ 
            $('.loading-overlay__spinner').addClass('hidden');
            $('.button-shop--now, .confirm_basket, .fbt_btn_add').removeClass('is-loading');
            $('.grid__item .cdk_quickView').attr('data-btn', 'quickview'); 
            $('.grid__item .quick-view-wrapper').hide();  
            updateMiniCart(currentThis); 
            cartCount();
            
          },
          error: function(jqXHR, textStatus, errorThrown) {
            $('.loading-overlay__spinner').addClass('hidden');
            $('.button-shop--now, .confirm_basket, .fbt_btn_add').removeClass('is-loading');
            if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
            if(jqXHR.status == 422) { alert(jqXHR.responseJSON.description); }
          }
        });
    }
 
    $(document).ready(function(){
        $(".product-swatches .cdk_close_icon").click(function(){  
          $('.grid__item .cdk_quickView').attr('data-btn', 'quickview');
          $('.grid__item .quick-view-wrapper').hide(); 
        });  
    });

    $(document).mouseup(function(e){
        var container = $(".product-card-wrapper");
     
        // If the target of the click isn't the container
        if(!container.is(e.target) && container.has(e.target).length === 0){
          $('.grid__item .cdk_quickView').attr('data-btn', 'quickview'); 
          $('.grid__item .quick-view-wrapper').hide();   
        }
      });
    
    $(document).on('click','.button-shop--now[data-btn="quickview"]',function(){   
      $('.grid__item .cdk_quickView').attr('data-btn', 'quickview'); 
      $('.grid__item .quick-view-wrapper').hide();  
      $(this).parents('.grid__item').find('.quick-view-wrapper').show();  
      var thisParentId = $(this).attr('data-id');
      $('.quick-view-wrapper[data-id="'+thisParentId+'"] select.product_card-form__master-select').change();
    });
  
    $(document).on('click','.button-shop--now[data-btn="addToCart"]',function(){
      //$(".cdk_quickView.cdk_plus_icon").removeClass('transform');   
        var currentThis = $(this);var updateItems = [];var variantId =  $(this).attr('data-variant');var quantity = 1;   var selling_plan = $(this).attr('data-sellingplan'); var orderType = $(this).attr('data-type'); 
        //console.log('selling_plan::'+selling_plan);
      if(selling_plan == '' || selling_plan == 'undefined'){
        if(orderType == 'Preorder'){
          updateItems.push({ "id": variantId, "quantity": quantity, "properties": {"Preorder": "true"} });
        }else{
        updateItems.push({ "id": variantId, "quantity": quantity });  
        }
        
      }else{
        if(orderType == 'Preorder'){
          updateItems.push({ "id": variantId, "quantity": quantity, "selling_plan": selling_plan, "properties": {"Preorder": "true"} });
        }else{
          updateItems.push({ "id": variantId, "quantity": quantity, "selling_plan": selling_plan });
        }
      } 
       ajaxAddToCartProduct(currentThis,updateItems);currentThis.addClass('is-loading');currentThis.find('.loading-overlay__spinner').removeClass('hidden');
      
    });
  
    $(document).on("click",".confirm_basket" ,function() { 
      $(this).parents('.product-card-wrapper').find('.cdk_quickView[data-btn="addToCart"]').trigger("click");
      $(this).addClass('is-loading');
      $(this).find('.loading-overlay__spinner').removeClass('hidden');
    });

    $(document).on('click','.cdk--custom_subscription_options .subscription_pan_item',function(){  
        var thisParentId = $(this).parents('.quick-view-wrapper').attr('data-id'); 
       $('.quick-view-wrapper[data-id="'+thisParentId+'"] .cdk--custom_subscription_options .subscription_pan_item').removeClass('active');
       $(this).addClass('active');
       $('.quick-view-wrapper[data-id="'+thisParentId+'"] select.product_card-form__master-select').change();
     });
   
     
      $(document).on('click','.quick-view-wrapper .swatches-block .swatches-item-box .swatches-option', function () {
       var OptionName = $(this).attr('data-value');
       $(this).parents('.swatches-item-box').find('.swatches-option').removeClass('selected');
       $(this).addClass('selected');
       $(this).parents('.swatches-block').find('select').val(OptionName).change();
       //console.log("OptionName::"+OptionName);
     })
     
     $(document).on('change','.quick-view-wrapper .swatches-block select', function () {
       var FinalValue = '';
       var thisParentId = $(this).parents('.quick-view-wrapper').attr('data-id');
       //console.log('thisParentId::'+thisParentId);
       $('.quick-view-wrapper[data-id="'+thisParentId+'"] .swatches-block').each(function() {
         var selectVal = $(this).find('select').val();
         FinalValue += selectVal+' / ';
         //console.log('selectVal::'+selectVal);
       });
       var newstr = FinalValue.substring(0, FinalValue.length - 3);
         //console.log('newstr::'+newstr);
    
       
       var optionName_Selector = $('.quick-view-wrapper[data-id="'+thisParentId+'"] select.product_card-form__master-select option[check-data-sku="'+newstr+'"]')
        var optionName_val = optionName_Selector.val();
    
       $('.quick-view-wrapper[data-id="'+thisParentId+'"] select.product_card-form__master-select').val(optionName_val).change();
    
       })
   
   
       $(document).on('change','.quick-view-wrapper select.product_card-form__master-select', function () {
         var thisMainVal = $(this).val(); 
         var thisParentId = $(this).parents('.quick-view-wrapper').attr('data-id');
         //console.log('thisMainVal::'+thisMainVal);
         // console.log('thisParentId::'+thisParentId);
         var thiSubType = $('.quick-view-wrapper[data-id="'+thisParentId+'"] .cdk--custom_subscription_options .subscription_pan_item.active').attr('data-type');
         //console.log('thiSubType::'+thiSubType);
         var ThisSellingPlan = $('.quick-view-wrapper[data-id="'+thisParentId+'"] .cdk_prod_selling_palns').val();
         //console.log('ThisSellingPlan::'+ThisSellingPlan);
         var ThisProdAvail =$(this).find('option[value="'+thisMainVal+'"]').attr('data-varaint-availability');
         //console.log('ThisProdAvail::'+ThisProdAvail);
         var ThisProdNP =$(this).find('option[value="'+thisMainVal+'"]').attr('data-price');
         //console.log('ThisProdNP::'+ThisProdNP);
         var ThisProdSP =$(this).find('option[value="'+thisMainVal+'"]').attr('data-price-sp');
         //console.log('ThisProdSP::'+ThisProdSP);
         var ThisOrderType =$(this).find('option[value="'+thisMainVal+'"]').attr('data-type');
         //console.log('ThisOrderType::'+ThisOrderType);
         
        if(thiSubType == 'subscription'){
          $('.cdk_quickView[data-id="'+thisParentId+'"]').attr('data-sellingplan',ThisSellingPlan);
          $('.quick-view-wrapper[data-id="'+thisParentId+'"]').find('.cdk_quick_price').find('.price-item').text(ThisProdNP);
          $('.quick-view-wrapper[data-id="'+thisParentId+'"]').find('.cdk_quick_price').find('.hawkstonine_price_text').text(ThisProdSP);
          $('.quick-view-wrapper[data-id="'+thisParentId+'"]').find('.cdk_quick_price').find('.price__regular').addClass('cdk-price-strike');
          $('.quick-view-wrapper[data-id="'+thisParentId+'"]').find('.cdk_subscription').show();
        }else{
         $('.cdk_quickView[data-id="'+thisParentId+'"]').attr('data-sellingplan',''); 
          $('.quick-view-wrapper[data-id="'+thisParentId+'"]').find('.cdk_quick_price').find('.price-item').text(ThisProdNP);
          $('.quick-view-wrapper[data-id="'+thisParentId+'"]').find('.cdk_quick_price').find('.price__regular').removeClass('cdk-price-strike');
          $('.quick-view-wrapper[data-id="'+thisParentId+'"]').find('.cdk_quick_price').find('.hawkstonine_price_text').text(ThisProdSP);
          $('.quick-view-wrapper[data-id="'+thisParentId+'"]').find('.cdk_subscription').hide();
        }
         $('.cdk_quickView[data-id="'+thisParentId+'"]').attr('data-variant', thisMainVal);
         if (ThisProdAvail == 'true'){
           if (ThisOrderType == 'Preorder'){
             $('.cdk_quickView[data-id="'+thisParentId+'"]').find('.btn_text').text('Preorder');
             $('.cdk_quickView[data-id="'+thisParentId+'"]').parents('.product-card-wrapper').find('.confirm_text').text('Preorder');
             $('.cdk_quickView[data-id="'+thisParentId+'"]').parents('.product-card-wrapper').find('.confirm_basket').removeClass('soldout');
             $('.cdk_quickView[data-id="'+thisParentId+'"]').parents('.product-card-wrapper').find('.confirm_basket').addClass('add');
           }else{
            $('.cdk_quickView[data-id="'+thisParentId+'"]').find('.btn_text').text('Add To Basket'); 
             $('.cdk_quickView[data-id="'+thisParentId+'"]').parents('.product-card-wrapper').find('.confirm_text').text('confirm selection');
             $('.cdk_quickView[data-id="'+thisParentId+'"]').parents('.product-card-wrapper').find('.confirm_basket').addClass('add');
             $('.cdk_quickView[data-id="'+thisParentId+'"]').parents('.product-card-wrapper').find('.confirm_basket').removeClass('soldout');
           }
            $('.cdk_quickView[data-id="'+thisParentId+'"]').attr('data-btn', 'addToCart');
         }else{
           $('.cdk_quickView[data-id="'+thisParentId+'"]').find('.btn_text').text('Sold Out');
           $('.cdk_quickView[data-id="'+thisParentId+'"]').attr('data-btn', 'soldout');
           $('.cdk_quickView[data-id="'+thisParentId+'"]').parents('.product-card-wrapper').find('.confirm_text').text('Sold Out');
           $('.cdk_quickView[data-id="'+thisParentId+'"]').parents('.product-card-wrapper').find('.confirm_basket').addClass('soldout');
           $('.cdk_quickView[data-id="'+thisParentId+'"]').parents('.product-card-wrapper').find('.confirm_basket').removeClass('add');
         } 
         
       })
   
     $(document).on("click",".recharge-subscription-widget .rc-widget .rc-template__button-group  .rc-radio" ,function() { 
      setTimeout(function () {
        $('variant-radios .product-form__input input:checked+label').click();
      },500)
     });
})